import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.palette.background.paper};
	border-radius: 8px;
`;

export {StyledStack};
